require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sponsors-actuels-du-sps-1-1-5-3.json") })
        }
      }, "path---sponsors-actuels-du-sps-1-1-5-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sponsors-actuels-du-sps-1-1-5-3!./.cache/json/sponsors-actuels-du-sps-1-1-5-3.json
// module id = 574
// module chunks = 231608221292675